'use client';

import { ComponentProps, FC, useState } from 'react';

import { CTAButton } from 'src/general/components/Button/CTAButton';
import { MaskedImage } from 'src/hygiene/components/MaskedImage/MaskedImage';
import { ValuePropLineItem } from 'src/hygiene/components/ValuePropLineItem/ValuePropLineItem';
import { FlexibleSection } from 'src/hygiene/sections/flexible-content/flexibleContent.type';
import { getSectionClasses } from 'src/hygiene/sections/flexible-content/getSectionClasses.helper';
import { getOr } from 'src/utils/getOr';

import { PerkSection } from './PerkSection/PerkSection';

interface Props extends FlexibleSection {
  sectionData: {
    tabSection: {
      label: string;
      header: string;
      subHeader: string;
      lines: ComponentProps<typeof ValuePropLineItem>[];
      desktopImage: string;
      mobileImage: string;
      cta: ComponentProps<typeof CTAButton>[];
    }[];
  };
}

export const TabSection: FC<Props> = ({ sectionData: { tabSection }, sectionBackground }) => {
  const [currentImage, setCurrentImage] = useState<{ mobileImage: string; desktopImage: string }>(
    getOr(tabSection, '0', { mobileImage: '', desktopImage: '' }),
  );
  const tabs = tabSection.map(({ label, ...content }) => ({
    label,
    content,
  }));

  const onTabChange = (index: number) => {
    const { desktopImage, mobileImage } = tabSection[index];
    setCurrentImage({ mobileImage, desktopImage });
  };

  return (
    <section className={getSectionClasses(sectionBackground, 'small')}>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-16">
        <div>
          <PerkSection tabs={tabs} onTabChange={onTabChange} />
        </div>
        <div>
          <MaskedImage
            image={currentImage.mobileImage}
            width={336}
            height={318}
            className="block md:hidden"
            maskPosition="top"
            priority
          />
          <MaskedImage
            image={currentImage.desktopImage}
            width={524}
            height={428}
            className="hidden h-full md:block"
            maskPosition="left"
            priority
          />
        </div>
      </div>
    </section>
  );
};
